import { createShiftParticipantHistory } from '../utils/createShiftParticipantHistory';
import { getShiftParticipantStorage } from '../utils/getShiftParticipantStorage';
export function moveRestParticipationsToPending(context, shiftId, missionTypeId, participation) {
    const restVolunteerParticipations = getShiftParticipantStorage(context).list({
        filter: [
            {
                column: 'shiftId',
                op: '=',
                value: shiftId,
            },
            {
                column: 'participantId',
                op: '=',
                value: participation.shiftParticipantId,
            },
            {
                id: participation.shiftParticipationId,
                op: '!=',
            },
            {
                column: 'status',
                op: '!=',
                value: 'pending',
            },
        ],
    });
    restVolunteerParticipations.rows.forEach((participationData) => {
        createShiftParticipantHistory(context, {
            participationId: participationData.id,
            shiftId: shiftId,
            participantId: participationData.columns.participantId,
            status: 'pending',
            missionTypeId: missionTypeId,
        });
    });
}
